import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import styled from '@emotion/styled'
import { useNavigate } from "react-router-dom";

const SearchBarWrapper = styled.article`
    width: 100%;
    > p {
        display: flex;
        align-items: center;
        padding: 10px 25px 0;
        min-height: 40px;
        color: var(--color-red-error);
    }
    > div {
        position: relative;
        display: flex;
        align-items: center;
        > input {
            padding: 14.5px 25px;
            font-size: 15px;
            border-radius: 25px;
            font-family: inherit;
            font-weight: 700;
            box-shadow: -5px -5px 10px 0px rgba(255, 255, 255, 0.75) inset, 5px 5px 10px 0px rgba(0, 0, 0, 0.05) inset;
            background-color: inherit;
            &::placeholder {
                color: var(--color-black-200);
                font-weight: 300;
                opacity: 1;
            }
        }
        > button {
            padding: 7.5px;
            aspect-ratio: 1/1;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 10px;
            border-radius: 99999px;
            width: 30px;
            background-color: inherit;
            box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.75), 2px 2px 5px 0px rgba(0, 0, 0, 0.05);
            &:hover{
                box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.75) inset, 2px 2px 5px 0px rgba(0, 0, 0, 0.05) inset;
            }
            img {
                display: block;
                width: 100%;
            }
        }
    }

`

const SearchBar = ({inputValue})=>{
    const [messageInput, setMessageInput] = useState("");
    const navigate = useNavigate();
    let searchInputRef = useRef(null);

    const getLetterCount = (string) => {

        const reKorean = /[^(가-힣)]/;
        const reEnglishNumber = /[^(a-zA-Z0-9)]/;

        const arrString = string.split("")

        let letterLength = 0;

        arrString.forEach((letter)=>{
            if( !reKorean.test(letter) ){
                letterLength = letterLength + 2;
            } else if ( !reEnglishNumber.test(letter) ) {
                letterLength = letterLength + 1;
            }
        })

        return letterLength;

    }

    const reNickname = /[^(가-힣a-zA-Z0-9)]/;

    const moveToCharactorInfo = ()=>{
        if( 
            getLetterCount(searchInputRef.current.value) < 4 ||
            reNickname.test(searchInputRef.current.value) ||
            getLetterCount(searchInputRef.current.value) > 12
        ) {
            setMessageInput("올바른 캐릭터 이름을 입력해주세요.")
        } else {
            const fetchData = async () => {
                try {
                  // 주어진 URL에 GET 요청 보내기
                  const response = await axios.get(`https://maple-frieza.com/data/combat-power/${searchInputRef.current.value}`);
                  setMessageInput("")
                  navigate(`/charactor-info/${searchInputRef.current.value}`, {
                      state:{
                          data:response.data
                      }
                  })
                } catch (error) {
                    setMessageInput("올바른 캐릭터 이름을 입력해주세요.")
                }
            };
          
              // 컴포넌트가 마운트될 때 데이터를 가져오도록 설정
            fetchData();
        }
    }

    const removeStringSpace = () => {
        var str_space = /\s/;
        let inputValue = searchInputRef.current.value;
        if(str_space.exec(inputValue)) { 
            searchInputRef.current.focus();
            searchInputRef.current.value = searchInputRef.current.value.replace(/\s| /gi,'');
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            moveToCharactorInfo()
        }
    };

    useEffect(()=>{
        if (inputValue && searchInputRef.current) {
            searchInputRef.current.value = inputValue;
        }
    },[searchInputRef, inputValue])
    return (
        <SearchBarWrapper>
            <p aria-live="polite">
                {messageInput}
            </p>
            <div>
                <input name="search" id="input-search" type="text" placeholder="캐릭터 이름을 입력해주세요." ref={searchInputRef} onKeyDown={handleKeyDown} onChange={removeStringSpace}/>
                <button onClick={moveToCharactorInfo}>
                    <img src="/image/icon/icon_arrow_right_blue.svg" alt="입력한 캐릭터 정보 조회" />
                </button>
            </div>
        </SearchBarWrapper>
    )
}

export default SearchBar;